import React from 'react';

export default function useStateWithInputEventHandler<T = any>(
  initial
): [T, (e: any) => void, (e: T) => void, () => void] {
  const [state, setState] = React.useState<T>(initial);

  function handler(e) {
    const { value, name, type, checked } = e.target;
    const valueType = typeof state;
    if (['string', 'number'].includes(valueType)) {
      return setState(value);
    }

    switch (type) {
      case 'checkbox':
        setState({ ...state, [name]: checked });
        break;
      default:
        setState({ ...state, [name]: value });
    }
  }

  function clear() {
    setState(initial);
  }

  return [state, handler, setState, clear];
}
